import React from "react";
import ReactApexChart from "react-apexcharts";
import Loader from "../../../components/loader/loder";

const ActiveDoctorsChart = ({ activeDoctorsData, chartLoading }) => {

    const getChartOptions = () => {
        if (!activeDoctorsData || !activeDoctorsData.dailyBreakdown) {
            return null;
        }

        const dates = activeDoctorsData.dailyBreakdown.map(item => item.date);
        const counts = activeDoctorsData.dailyBreakdown.map(item => item.activeDoctorsCount);

        return {
            series: [{
                name: 'Active Doctors',
                data: counts
            }],
            options: {
                chart: {
                    type: 'bar',
                    height: 350,
                    fontFamily: 'Inter, sans-serif',
                    toolbar: {
                        show: false
                    },
                    animations: {
                        enabled: true,
                        easing: 'ease-inout',
                        speed: 700
                    }
                },

                plotOptions: {
                    bar: {
                        borderRadius: 6,
                        columnWidth: '45%',
                        dataLabels: {
                            position: 'top'
                        }
                    }
                },

                dataLabels: {
                    enabled: true,
                    offsetY: -25,
                    style: {
                        fontSize: '14px',
                        fontWeight: 600,
                        colors: ['#ffffff']
                    },
                    background: {
                        enabled: true,
                        foreColor: '#064e3b',
                        borderRadius: 6,
                        padding: 6,
                        opacity: 0.95,
                        borderWidth: 1,
                        borderColor: '#99f6e4'
                    }
                },

                colors: ['#c8fff2'],

                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'light',
                        type: 'vertical',
                        shadeIntensity: 0.5,
                        gradientToColors: ['#46A4A3'],
                        inverseColors: false,
                        opacityFrom: 0.95,
                        opacityTo: 0.85,
                        stops: [0, 100]
                    }
                },

                grid: {
                    borderColor: '#e5e7eb',
                    strokeDashArray: 4,
                    padding: {
                        top: 20,
                        bottom: 0,
                        left: 10,
                        right: 10
                    }
                },

                xaxis: {
                    categories: dates,
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    },
                    labels: {
                        rotate: -45,
                        style: {
                            fontSize: '12px',
                            colors: '#6b7280'
                        }
                    }
                },

                yaxis: {
                    title: {
                        text: 'Active Doctors',
                        style: {
                            fontSize: '12px',
                            fontWeight: 600,
                            color: '#374151'
                        }
                    },
                    labels: {
                        style: {
                            fontSize: '11px',
                            colors: '#6b7280'
                        }
                    }
                },

                tooltip: {
                    theme: 'light',
                    style: {
                        fontSize: '12px'
                    },
                    y: {
                        formatter: (val) => `${val} doctors`
                    }
                }
            }
        };
    };

    const chartData = getChartOptions();

    return (
        <div className="bg-white rounded-md p-5 drop-shadow-[0_0px_20px_rgba(203,229,255,0.5)]">
            <div className="flex flex-col gap-4">
                <h1 className="font-bold text-lg text-primary">
                    Active Doctors By Date
                    {activeDoctorsData && (
                        <span className="text-sm font-normal text-gray-600 ml-2">
                            (Total: {activeDoctorsData.totalActiveDoctors})
                        </span>
                    )}
                </h1>

                {chartLoading ? (
                    <div className="flex justify-center items-center h-64">
                        <Loader />
                    </div>
                ) : chartData ? (
                    <ReactApexChart
                        options={chartData.options}
                        series={chartData.series}
                        type="bar"
                        height={350}
                    />
                ) : (
                    <div className="flex justify-center items-center h-64 text-gray-500">
                        No data available for the selected date range
                    </div>
                )}
            </div>
        </div>
    );
};

export default ActiveDoctorsChart;
